import React from 'react'

const Empty = () => {
  return (
     <div className="flex items-center font-bold text-[1.5rem] text-center text-lightgreen justify-center  gap-y-[1rem] p-[1rem]  w-full h-[9rem] border rounded-lg bg-white drop-shadow-lg  ">
   <h1>No shares has been bought</h1>
  </div>
  )
}

export default Empty